import { userService, alertService} from "../_services";

/**
 * Calls userService to validate address of submissionData.
 * @param {object} submissionData : dict that has an address 
 * @param {string} path : dot delimited string that is the nested key path to address 
 * @returns {boolean} success/fail as to if the validation 
 */
export const verifyAddress = async (submissionData, path) => {
    // Traverse submissionData to change the right obj
    const keys = path.split('.');
    let current = submissionData;
    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        current = current[key];
    }
    const addressKey = keys[keys.length - 1];
    let success = await userService.validateAddress(current[addressKey])
        .then(resp => {
            if(!!resp.changed){
                // If changed then we don't update and set a warning of validated address
                var addressString = `
                        ${resp.message.street_address_1}, ${resp.message.city}, ${resp.message.state}, ${resp.message.postal_code}
                `;
                if(!!resp.message.street_address_2){
                    addressString = `
                        ${resp.message.street_address_1}, ${resp.message.street_address_2}, ${resp.message.city}, ${resp.message.state}, ${resp.message.postal_code}
                    `;
                }
                
                alertService.warn(`Validated address to: ${addressString}`);
                alertService.info('Consider changing address input.', {autoClose: true});
                return false;
            }else{
                // Address was validated and unchanged so we assign to original object and return success
                current[addressKey] = resp.message;
                return true;
            }
        })
        .catch(error => {
            alertService.error(error);
            return false;
        });
    return success;
}